import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';

import { repeatable, stringInputSpec } from '../../lib/editing-configs';

const InsuranceSummaryTableWrapper = ({ marketplaceEntities = [] }) => {
  const marketplaceEntityIds = useMemo(
    () =>
      marketplaceEntities
        .map((marketplaceEntity) => marketplaceEntity?.id)
        .filter((marketplaceEntityId) => !!marketplaceEntityId),
    [marketplaceEntities]
  );

  if (marketplaceEntityIds?.length === 0) {
    return null;
  }

  return (
    <StructuredContent>
      {{
        type: 'InsuranceSummaryTable',
        version: '1.0.0',
        props: {
          marketplaceEntityIds,
        },
      }}
    </StructuredContent>
  );
};

InsuranceSummaryTableWrapper.propTypes = {
  marketplaceEntities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
};

InsuranceSummaryTableWrapper.defaultProps = {
  marketplaceEntities: [],
};

InsuranceSummaryTableWrapper.getEditingConfig = () => {
  return [
    repeatable(
      'marketplaceEntities',
      'Marketplace Entities',
      'Makertplace Entity',
      () => [stringInputSpec('id', 'Marketplace Entity ID')]
    ),
  ];
};

InsuranceSummaryTableWrapper.displayName = 'Insurance Summary Table Wrapper';

export default InsuranceSummaryTableWrapper;
